// VIBRANIAM-SPACE v2 - forces.js
// Metadata for the force kinds. The p-slot indices must match forces.h.

export const FORCE_KINDS = [
  {
    kind: 0, key: 'drift', label: 'Deriva',
    hint: 'Spinta costante in una direzione.',
    params: [
      { p: 0, key: 'dx', label: 'X', min: -4, max: 4, step: 0.01, def: 0 },
      { p: 1, key: 'dy', label: 'Y', min: -4, max: 4, step: 0.01, def: 0.2 },
      { p: 2, key: 'dz', label: 'Z', min: -4, max: 4, step: 0.01, def: 0 },
    ],
  },
  {
    kind: 1, key: 'gravity', label: 'Gravita',
    hint: 'Accelerazione verso il basso.',
    params: [{ p: 0, key: 'g', label: 'g', min: -6, max: 6, step: 0.01, def: 1 }],
  },
  {
    kind: 2, key: 'drag', label: 'Attrito',
    hint: 'Smorza la velocita. Quasi sempre serve: senza, tutto esplode.',
    params: [{ p: 0, key: 'k', label: 'Coeff.', min: 0, max: 6, step: 0.01, def: 0.55 }],
  },
  {
    kind: 3, key: 'curl', label: 'Turbolenza curl',
    hint: 'Rumore 1/f a divergenza nulla: filamenti, non nebbia.',
    params: [
      { p: 0, key: 'freq',    label: 'Frequenza', min: 0.05, max: 4, step: 0.01, def: 0.45 },
      { p: 1, key: 'octaves', label: 'Ottave',    min: 1, max: 6, step: 1, def: 3 },
      { p: 2, key: 'evolve',  label: 'Evoluzione',min: 0, max: 2, step: 0.01, def: 0.25 },
    ],
  },
  {
    kind: 4, key: 'lorenz', label: 'Lorenz',
    hint: 'Attrattore caotico usato come campo di velocita.',
    params: [
      { p: 0, key: 'sigma', label: 'Sigma', min: 1, max: 20, step: 0.1, def: 10 },
      { p: 1, key: 'rho',   label: 'Rho',   min: 1, max: 60, step: 0.1, def: 28 },
      { p: 2, key: 'beta',  label: 'Beta',  min: 0.1, max: 6, step: 0.01, def: 2.6667 },
      { p: 3, key: 'scale', label: 'Scala', min: 0.2, max: 6, step: 0.01, def: 3.2 },
    ],
  },
  {
    kind: 5, key: 'spiral', label: 'Spirale aurea',
    hint: 'Fillotassi: angolo aureo per indice, raggio sqrt(n).',
    params: [
      { p: 0, key: 'rate',      label: 'Rotazione', min: -4, max: 4, step: 0.01, def: 1 },
      { p: 1, key: 'radius',    label: 'Raggio',    min: 0.1, max: 6, step: 0.01, def: 1 },
      { p: 2, key: 'rise',      label: 'Salita',    min: -2, max: 2, step: 0.01, def: 0.35 },
      { p: 3, key: 'stiffness', label: 'Rigidita',  min: 0.1, max: 12, step: 0.05, def: 3.5 },
    ],
  },
  {
    kind: 6, key: 'vortex', label: 'Vortice',
    hint: 'Rotazione attorno a un asse, con caduta sulla distanza.',
    params: [
      { p: 0, key: 'ax',      label: 'Asse X',  min: -1, max: 1, step: 0.01, def: 0 },
      { p: 1, key: 'ay',      label: 'Asse Y',  min: -1, max: 1, step: 0.01, def: 1 },
      { p: 2, key: 'az',      label: 'Asse Z',  min: -1, max: 1, step: 0.01, def: 0 },
      { p: 3, key: 'falloff', label: 'Caduta',  min: 0, max: 2, step: 0.01, def: 0.15 },
    ],
  },
  {
    kind: 7, key: 'attractor', label: 'Attrattore',
    hint: 'Punto che attrae (positivo) o respinge (negativo).',
    params: [
      { p: 0, key: 'x',        label: 'X',        min: -4, max: 4, step: 0.01, def: 0 },
      { p: 1, key: 'y',        label: 'Y',        min: -4, max: 4, step: 0.01, def: 0 },
      { p: 2, key: 'z',        label: 'Z',        min: -4, max: 4, step: 0.01, def: 0 },
      { p: 3, key: 'strength', label: 'Forza',    min: -8, max: 8, step: 0.01, def: 1 },
      { p: 4, key: 'soft',     label: 'Ammorb.',  min: 0.02, max: 2, step: 0.01, def: 0.3 },
    ],
  },
  {
    kind: 8, key: 'spectral', label: 'Forza spettrale',
    hint: 'Ogni banda FFT spinge le sue particelle in una direzione propria.',
    params: [
      { p: 1, key: 'spread', label: 'Apertura', min: 0.1, max: 4, step: 0.01, def: 1 },
      { p: 2, key: 'radial', label: 'Radiale',  min: 0, max: 1, step: 0.01, def: 0.5 },
    ],
  },
  {
    kind: 9, key: 'boundary', label: 'Confine',
    hint: 'Sfera morbida che tiene tutto in campo.',
    params: [
      { p: 0, key: 'radius',    label: 'Raggio',   min: 0.5, max: 12, step: 0.05, def: 4.5 },
      { p: 1, key: 'stiffness', label: 'Rigidita', min: 0, max: 20, step: 0.05, def: 2.2 },
    ],
  },
];

export const forceByKind = (k) => FORCE_KINDS.find((f) => f.kind === Number(k)) || FORCE_KINDS[0];
export const forceByKey  = (k) => FORCE_KINDS.find((f) => f.key === k) || FORCE_KINDS[0];

/** Builds the 8-float p array the WASM side expects from named params. */
export function packForceParams(kind, params) {
  const def = forceByKind(kind);
  const p = new Array(8).fill(0);
  for (const spec of def.params) {
    const v = params[spec.key];
    p[spec.p] = Number.isFinite(v) ? v : spec.def;
  }
  return p;
}

/** Default named params for a kind. */
export function defaultForceParams(kind) {
  const out = {};
  for (const spec of forceByKind(kind).params) out[spec.key] = spec.def;
  return out;
}
